import React from "react";
var SidebarSection = function SidebarSection(_ref) {
    var heading = _ref.heading, children = _ref.children, headClassName = _ref.headClassName, backgroundColor = _ref.backgroundColor;
    return /*#__PURE__*/ React.createElement("div", {
        className: "border-t-8 border-solid border-makroOrange mb-5 pb-3 " + backgroundColor
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-xl mb-2 " + headClassName + " " + (heading != 'EUROpa' ? 'uppercase' : '')
    }, heading), children);
};
export default SidebarSection;
